import classNames from "classnames";
import React, { useState } from "react";
import { InputLabel } from "@material-ui/core";
import "./input.scss";

const CustomeInput = ({
  name,
  label,
  showLabel,
  error,
  validation,
  childHasError,
  columnDataArr,
  value,
  classes,
  tableName,
  readonly,
  ...props
}) => {
  const [hasError, setError] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  const handleOnChange = (e) => {
    const newValue = e.target.value;

    const allowed = props.onChange(name, newValue);

    // ❌ STOP updating internal state if rejected
    if (allowed === false) return;

    setInputValue(e.target.value);
  };

  return (
    <>
      <div
        className={classNames(
          classes.inputWrapperDiv,
          `inputWrapperDiv${tableName}`
        )}
      >
        <InputLabel
          className={classNames(
            classes.selectInputLabel,
            `selectInputLabel_${tableName}`
          )}
          htmlFor={name}
          style={{ fontSize: "12px", marginBottom: "2px" }}
        >
          {label}
        </InputLabel>

        {showLabel ? (
          <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
            <input type="checkbox" />
            <InputLabel
              className={classNames(
                classes.selectInputLabel,
                `selectInputLabel_${tableName}`
              )}
              htmlFor={name}
              style={{ fontSize: "12px" }}
            >
              {inputValue === null || inputValue === undefined
                ? "None"
                : inputValue}
            </InputLabel>
          </div>
        ) : (
          <>
            <input
              className={classNames(
                classes.input,
                `input${tableName}`,
                "custom-input-field"
              )}
              style={{
                borderBottom: `${
                  readonly ? "1px solid #cccccc" : "1px solid #4a4a4a"
                }`,
                color: `${readonly ? "#cccccc" : "black"}`,
                fontSize: "13px",
              }}
              name={name}
              value={inputValue}
              onChange={handleOnChange}
              disabled={readonly}
            />
            <p className={classNames(classes.error, `error${tableName}`)}>
              {hasError && error}
            </p>
          </>
        )}
      </div>
    </>
  );
};

export default CustomeInput;
